// API Models

export interface ApiPharmAddressResponse {
  customerAddressId: string;
  customerId: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
}

export type ApiGetPharmAddressResponse = ApiPharmAddressResponse;

/*
export interface ApiPharmAddressRequest {
  pharmacy?: string;
  customerId?: string;
  customerAddressId?: string;
}
*/

// Front End Models

export interface PharmAddress {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
}

//export interface UpdatePharmAddressForm extends ApiPharmAddressRequest {}

// Mappers

export const mapPharmAddress = (p: ApiPharmAddressResponse): PharmAddress => {
  return {
    ...p,
    address1: p.address1,
    address2: p.address2,
    city: p.city,
    state: p.state,
    zip: p.zipCode,
  };
};
